// src/context/TimerContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const TimerContext = createContext();

export const TimerProvider = ({ children }) => {
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [timerMode, setTimerMode] = useState('work');
    const [timeLeft, setTimeLeft] = useState(0);
    const [workDuration, setWorkDuration] = useState(25);
    const [breakDuration, setBreakDuration] = useState(5);

    useEffect(() => {
        let interval;
        if (isTimerRunning) {
            interval = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        // Timer will reach 0 in the next render
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [isTimerRunning]);

    return (
        <TimerContext.Provider value={{
            isTimerRunning,
            setIsTimerRunning,
            timerMode,
            setTimerMode,
            timeLeft,
            setTimeLeft,
            workDuration,
            setWorkDuration,
            breakDuration,
            setBreakDuration
        }}>
            {children}
        </TimerContext.Provider>
    );
};

export const useTimer = () => useContext(TimerContext);